import { IImage, IVideo } from '../media';
import { IUserAuthInfo } from 'shared/models/user-auth-info';

export enum ECommentPermission {
  All = 0, // 显示评论区
  Follower = 1, // 粉丝可评论
  Self = 2, // 自己可评论
  Disable = 3, // 不可评论，不显示评论区
  Friend = 4, // 好友可评论
}

export interface GalleryLabelType {
  direction: string;
  id: string;
  imageIndex: number;
  name: string;
  type: string;
  xPct: number;
  yPct: number;
}

export enum EArticleClass {
  GALLERY = 'Gallery',
  VIDEO = 'Video',
  ARTICLE = 'Article',
}

export interface IIllegalInfo {
  warningLabel: string;
  warningLabelType: number;
}

export interface IArticleDetail {
  groupId: string;
  templateId?: string;
  imprId?: string;

  // author
  author: {
    userId: string;
    avatar: string;
    authInfo: IUserAuthInfo;
    nickName: string;
    linkName: string;
  };

  // content
  articleClass: EArticleClass;

  // TODO cast to i18n:Region
  articleRegion: string;
  title: string;
  content: string;
  shortContent: string;

  translatedRegions?: string[];
  isTranslatedVersion?: boolean;

  gptSummary?: string;

  // content publish time
  publishTime: number;
  modifyTime?: number;

  // interaction
  readCount: number;
  diggCount: number;
  favoriteCount: number;
  commentCount: number;

  // legacy hashtag
  forumList?: {
    id: string;
    name: string;
  }[];

  // poi
  locationInfo?: {
    poiId: string;
    poiName: string;
  };

  // search after read
  relatedQuery?: string;
  relatedQueryInfos: { word: string }[];

  // privacy & safety
  isOnlyFollow: boolean;
  commentPermission: ECommentPermission;
  illegalInfo?: IIllegalInfo;
}

export interface IVideoArticleDetail extends IArticleDetail {
  articleClass: EArticleClass.VIDEO;
  largeImage: IImage;
  video: IVideo & { encryptedUrl?: string; ocr?: string[] };
}

export interface IGalleryArticleDetail extends IArticleDetail {
  articleClass: EArticleClass.GALLERY;
  imageList: IImage[];
  galleryLabels: GalleryLabelType[];
  ocrText?: string[]; // ocr识别文字
  imageAutoGenDesp?: string[]; // 图片描述自动生成
}

export interface IRichArticleDetail extends IArticleDetail {
  articleClass: EArticleClass.ARTICLE;
  largeImage: IImage;
}

export type TArticleDetail = IVideoArticleDetail | IGalleryArticleDetail | IRichArticleDetail;
